import { QueryClient } from '@tanstack/react-query';

export const DASHBOARD_STALE_TIME = 5 * 60 * 1000;

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: DASHBOARD_STALE_TIME,
            gcTime: 30 * 60 * 1000,
            refetchOnWindowFocus: false,
            retry: false,
        },
    },
});
